<div class="mt-5 row">
  <div class="col-md-3">
    <mat-form-field>
      <mat-select placeholder="Tipo de Aportación:" (selectionChange)="selectedBonusTypeChange($event)" [value]="newBonusType">
        <mat-option>Seleccione el Tipo de Aportación</mat-option>
        <mat-option *ngFor="let type of bonusType"  [value]="type.value">
          {{type.name}}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div class="col-md-3">
    <mat-form-field>
      <input matInput [matDatepicker]="inicioDeCicloPicker" placeholder="Inicio:"
        (dateChange)="setRegistrationDate('starts', $event)" [value]="newRegistrationDate.startDate">
      <mat-datepicker-toggle matSuffix [for]="inicioDeCicloPicker"></mat-datepicker-toggle>
      <mat-datepicker #inicioDeCicloPicker></mat-datepicker>
    </mat-form-field>
  </div>

  <div class="col-md-3">
    <mat-form-field>
      <input matInput [matDatepicker]="finDeCicloPicker" placeholder="Fin:"
        (dateChange)="setRegistrationDate('ends', $event)" [value]="newRegistrationDate.endDate"
        [min]="newRegistrationDate.startDate" [disabled]="!newRegistrationDate.startDate">
      <mat-datepicker-toggle matSuffix [for]="finDeCicloPicker"></mat-datepicker-toggle>
      <mat-datepicker #finDeCicloPicker [disabled]="!newRegistrationDate.startDate"></mat-datepicker>
    </mat-form-field>
  </div>

</div>


<div class="row">
  <div class="col-md-4 offset-md-8 center-vertically">
    <button class="btn-block" mat-raised-button color="primary" (click)="addRegistrationDate()">Añadir Fechas</button>
  </div>
</div>

<div class="my-5 row border-top" *ngIf="modParameter.savingParameter.bonusPercentageForLoan.length > 0">
  <div class="col-md-12">

    <mat-table #registrationDatesTable class="table" [dataSource]="modParameter.savingParameter.bonusPercentageForLoan">
      <ng-container matColumnDef="Tipo">
        <mat-header-cell *matHeaderCellDef> Tipo Bono </mat-header-cell>
        <mat-cell *matCellDef="let element"> {{bonusName[element.bonus]}}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="Inicio">
        <mat-header-cell *matHeaderCellDef> Inicio </mat-header-cell>
        <mat-cell *matCellDef="let element"> {{element.period.startDate | date: 'mediumDate'}} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="Fin">
        <mat-header-cell *matHeaderCellDef> Fin </mat-header-cell>
        <mat-cell *matCellDef="let element"> {{element.period.endDate ? (element.period.endDate | date: 'mediumDate') :
              ''}}</mat-cell>
      </ng-container>
      <ng-container matColumnDef="active">
        <mat-header-cell *matHeaderCellDef> Fecha Activa </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <mat-checkbox [(ngModel)]="element.period.active" [disabled]="false">Fecha Activa</mat-checkbox>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="delete" class="center-text">
        <mat-header-cell *matHeaderCellDef><span>Eliminar</span></mat-header-cell>
        <mat-cell *matCellDef="let index ">
          <button mat-icon-button color="warn" (click)="deleteRegistrationDate(index)">
            <mat-icon aria-label="Delete">delete_outline</mat-icon>
          </button>

        </mat-cell>
      </ng-container>

      <mat-header-row mat-header-row *matHeaderRowDef="displayedRegistrationDatesColumns"></mat-header-row>
      <mat-row mat-row *matRowDef="let row; columns: displayedRegistrationDatesColumns;"></mat-row>

    </mat-table>

  </div>
</div>